import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
import { ca } from "date-fns/locale";

const scopes = [
    {
        name: capitalize(i18n.t("users")),
        id: 'users',
    },
    {
        name: capitalize(i18n.t("roles")),
        id: 'roles',
    },
    {
        name: capitalize(i18n.t("tags.templates")),
        id: 'config_tag',
    },
    {
        name: capitalize(i18n.t("products")),
        id: 'items',
    },
    {
        name: capitalize(i18n.t("stock")),
        id: 'stock',
    },

    {
        name: capitalize(i18n.t("persons")),
        id: 'persons',
    },
    {
        name: capitalize(i18n.t("devices")),
        id: 'devices',
    },
    {
        name: capitalize(i18n.t("locations")),
        id: 'locations'
    },
    {
        name: capitalize(i18n.t("branch.offices")),
        id: 'nodes'
    },
    {
        name: capitalize(i18n.t("external.applications")),
        id: 'apps'
    },
    {
        name: capitalize(i18n.t("orders")),
        id: 'orders'
    },
    {
        name: capitalize(i18n.t("alerts")),
        id: 'alerts'
    },
]


export const specificScopes = [
    {
        name: capitalize(i18n.t("generate.tags")),
        id: 'generate_config_tag',
    },
    {
        name: capitalize(i18n.t("admin.tags")),
        id: 'admin_tag',
    },
    {
        name: capitalize(i18n.t("admin.attributes")),
        id: 'admin_attributes',
    },
    {
        name: capitalize(i18n.t("items.load.file")),
        id: 'create_upload_items',
    },
    {
        name: capitalize(i18n.t("audit.stock")),
        id: 'auditory_stock',
    },
    {
        name: capitalize(i18n.t("location.stock")),
        id: 'localization_stock',
    },
    {
        name: capitalize(i18n.t("complete.order")),
        id: 'complete_orders',
    },
    {
        name: capitalize(i18n.t("reject.order")),
        id: 'reject_orders',
    },
    {
        name: capitalize(i18n.t("skip.order.supervision")),
        id: 'skip_order_supervision',
    },
]

export default scopes;